import styles from './MenuItemsListingSkeleton.module.scss';

const CategoryTabSkeleton = () => {
  return <div className={styles.categoryTab}></div>;
};

const ItemCardSkeleton = () => {
  return (
    <div className={styles.itemCard}>
      <div className={styles.itemDetails}>
        <div className={styles.details}>
          <div className={styles.itemName}></div>
          <div className={styles.itemDescription}></div>
        </div>
        <div className={styles.price}>
          <div className={styles.priceValue}></div>
          <div className={styles.cashbackValue}></div>
        </div>
      </div>
      <div className={styles.image}></div>
    </div>
  );
};

const CategorySkeleton = () => {
  return (
    <div className={styles.category}>
      <div className={styles.categoryHeader}></div>
      <div className={styles.categoryItems}>
        <ItemCardSkeleton />
        <ItemCardSkeleton />
        <ItemCardSkeleton />
      </div>
    </div>
  );
};

const MenuItemsListingSkeleton = () => {
  return (
    <div className={styles.menu} data-testid="menu-items-listing-skeleton">
      {/* Brand header skeleton */}
      <div className={styles.brandHeader}></div>

      {/* Navigation tabs skeleton */}
      <div className={styles.navigation}>
        <div className={styles.categoriesList}>
          <CategoryTabSkeleton />
          <CategoryTabSkeleton />
          <CategoryTabSkeleton />
          <CategoryTabSkeleton />
        </div>
        <div className={styles.menuButton}></div>
      </div>

      {/* Menu content skeleton */}
      <div className={styles.listing}>
        <CategorySkeleton />
        <CategorySkeleton />
        <CategorySkeleton />
      </div>
    </div>
  );
};

export default MenuItemsListingSkeleton;
